module.exports = __webpack_public_path__ + "img/字-素材.5d6acd9b.svg";